// @flow

import {DAYS} from '../constants/allowed-inputs';
export type CustomDateDay = {
  name: string,
  en_name: string,
};

export const allowedDaysToValues = (days: string[]): string[] => {
  return days.map(d => DAYS.find(el => el.value.includes(d))?.value ?? '');
};

export const allowedDaysToName = (days: string[]): string[] => {
  return days.map(d => DAYS.find(el => el.value.includes(d))?.name ?? '');
};

export const mapNumberToDay: {[key: string]: CustomDateDay} = {
  '0': {
    name: 'Domingo',
    en_name: 'Sunday',
  },
  '1': {
    name: 'Lunes',
    en_name: 'Monday',
  },
  '2': {
    name: 'Martes',
    en_name: 'Tuesday',
  },
  '3': {
    name: 'Miércoles',
    en_name: 'Wednesday',
  },
  '4': {
    name: 'Jueves',
    en_name: 'Thursday',
  },
  '5': {
    name: 'Viernes',
    en_name: 'Friday',
  },
  '6': {
    name: 'Sábado',
    en_name: 'Saturday',
  },
};
